import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Footer = styled.footer`
  width: min(64rem, calc(100% - 4rem));
  margin: 0 auto;
  padding: 32px 0 48px;
  background: var(--bg);
  border-top: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Copyright = styled.p`
  margin: 0;
  font-family: var(--font-sans);
  font-size: 16px;
  font-weight: 400;
  color: var(--text-muted);
  line-height: 1.4;
`;

const BackToTopLink = styled.a`
  font-family: var(--font-sans);
  font-size: 16px;
  font-weight: 400;
  color: var(--text-muted);
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: var(--text);
  }
`;

function bostonTime(date) {
  const clock = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(date);
  return `Boston, ${clock} ET`;
}

const PageFooter = () => {
  const [time, setTime] = useState(() => bostonTime(new Date()));

  useEffect(() => {
    const tick = () => setTime(bostonTime(new Date()));
    const id = window.setInterval(tick, 30000);
    return () => window.clearInterval(id);
  }, []);

  const onBackToTop = (event) => {
    event.preventDefault();
    const home = document.getElementById('home');
    if (home) {
      home.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Footer>
      <Copyright>© 2026 Sarah Jun</Copyright>
      <Copyright as="p">{time}</Copyright>
      <BackToTopLink href="#top" onClick={onBackToTop}>
        Back to top
      </BackToTopLink>
    </Footer>
  );
};

export default PageFooter;
